// Image import
import challImage from "styles/images/ranks/Challenger.png";
import gmImage from "styles/images/ranks/GrandMaster.png";
import masterImage from "styles/images/ranks/Master.png";
import diamImage from "styles/images/ranks/Diamond.png";
import emeraldImage from "styles/images/ranks/Emerald.webp";
import platImage from "styles/images/ranks/Platinium.webp";
import goldImage from "styles/images/ranks/Gold.webp";
import silverImage from "styles/images/ranks/Silver.png";
import bronzeImage from "styles/images/ranks/Bronze.png";
import ironImage from "styles/images/ranks/Iron.webp";

export function getRankImage(position: number): string {
  if (position === 1) return challImage;
  if (position === 2) return gmImage;
  if (position === 3) return masterImage;
  if (position >= 4 && position <= 10) return diamImage;
  if (position >= 11 && position <= 50) return emeraldImage;
  if (position >= 51 && position <= 100) return platImage;
  if (position >= 101 && position <= 500) return goldImage;
  if (position >= 501 && position <= 1000) return silverImage;
  if (position >= 1001 && position <= 5000) return bronzeImage;
  return ironImage; // For positions 5001 and above
}
